import { Autocomplete, Box, Button, Card, CircularProgress, FormControl, Grid, IconButton, MenuItem, Modal, Select, TextField, Tooltip, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, set, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import UnauthorizedPage from '../../../UnAuthorized';
import { SlabDataContext } from './SubscriptionSlab';
import { normalizeNumericInput } from '../../../../utils/formatNumber';
import { CrudServices } from '../../../MasterService/CrudServices';
import { SlabServices } from './SlabServices';
import { Close, ControlPointDuplicate, Help } from '@mui/icons-material';
import MultipleDuplicateSlabCreate from './Multiple/MultipleDuplicateSlabCreate';

const cities = [
    { cityId: 1, cityName: 'Noida', pinCodes: ['201301', '201302'] },
    { cityId: 2, cityName: 'Ghaziabad', pinCodes: ['110001', '110002'] },
    { cityId: 3, cityName: 'Gurugram', pinCodes: ['400001', '400002'] },
    // { cityId: 4, cityName: 'Bangalore', pinCodes: ['560001', '560002'] },
    // { cityId: 5, cityName: 'Chennai', pinCodes: ['600001', '600002'] },
];

const AddEditForm = () => {
    const {slabInitialData,slabData,setSlabData,selectedSlabData,setSelectedSlabData, urbanTypeList,fetchUrbanTypeList,categoryList, loadingCategoryList, fetchCategoryList, fetchSlabList,paginationModel,setPaginationModel} = useContext(SlabDataContext)
    const [pageTitle, setPageTitle] = useState('Add Slab');
    const {control,handleSubmit,formState:{isDirty},reset,watch,setValue} = useForm({
        mode:'onChange',
        defaultValues:slabData,
    });
    const [isSubmitted,setIsSubmitted] = useState(false);
    const onSubmit = async (data)=>{
        // setIsSubmitted(true);
        console.log("data:",data);
        const ModifiedData = {
            categoryId: data.categoryId,
            SubscriptionUrbanTypeId: data.SubscriptionUrbanTypeId,
            orderStart: data.orderStart,
            orderEnd: data.orderEnd,
            subscriptionFee: data.subscriptionFee,
            subscriptionFeeWithGst: data.subscriptionFeeWithGst,
            // status: false
        }
        Swal.fire({
            title:'Processing',
            text:'Please wait while we processing Submission request...',
            didOpen: () => {
                Swal.showLoading();
            }
        })
        try{
            if(selectedSlabData){
                //update
                const updateresponse = await SlabServices.updateSlabData(ModifiedData,selectedSlabData.id);
                if(updateresponse.success == '1'){
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data updated successfully',
                    })
                    fetchSlabList();
                    setSelectedSlabData(null);
                    setSlabData(slabInitialData);
                    reset(slabInitialData);
                    setPageTitle('Add Slab');
                }else if(updateresponse.success == '0'){                    
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: updateresponse.message || 'failed to update data',
                    })
                }
            }else{
                //save
                const saveresponse = await SlabServices.addNewSlab(ModifiedData);
                if(saveresponse.success == '1'){
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Data saved successfully',
                    })
                    fetchSlabList();
                    reset(slabInitialData);
                }else if(saveresponse.success == '0'){
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: saveresponse.message || 'failed to save data',
                    })
                }
            }
        }catch (error){
            console.log("error:",error)
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'failed to save data...Something went wrong!',
            })
        }finally{
            setIsSubmitted(false);
        }
    }
    useEffect(()=>{
        if(selectedSlabData){
            setPageTitle('Edit Slab Data');
            const modifiedData = {
                ...selectedSlabData,
                
            }
            setSlabData(modifiedData);
            reset(modifiedData,{isDirty:false});
            console.log("selected urban Data:",selectedSlabData)
        }
    },[selectedSlabData])

    
    const Submitting = ()=>{
        Swal.fire({
            title: 'Please wait...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    }
    const resetFormField = ()=>{
        reset(slabInitialData);
        setSelectedSlabData(null);
        setSlabData(slabInitialData);
        setPageTitle('Add Slab');
        setPaginationModel({
            ...paginationModel,
            filters: {
            ...paginationModel.filters,
            searchKey: "",
            sortBy: 'createdAt',
            sortType: 'desc',
            filterOptions: []
            }
        });
    }    
    useEffect(()=>{
        fetchCategoryList();
        fetchUrbanTypeList();
    },[])

    const category = watch('categoryId');
    const subscriptionRegion = watch('SubscriptionUrbanTypeId');
    const lastSlabDetails = async () =>{
        const response = await SlabServices.fetchlastSlabDetails(category,subscriptionRegion);
        if(response.success== '1'){
            if(response.data?.orderEnd){
                setValue('orderStart',parseInt(response.data.orderEnd) + 1);
            }
        } else{
            setValue('orderStart',0);
        }
    }
    useEffect(()=>{
        if(category && subscriptionRegion){
            setPaginationModel({
                ...paginationModel,
                filters: {
                ...paginationModel.filters,
                searchKey: "",
                sortBy: 'createdAt',
                sortType: 'desc',
                filterOptions: [
                        {
                            "fieldName": "categoryId",
                            "operator": "equals",
                            "value": category,
                            "andOr": "and"
                        },
                        {
                            "fieldName": "SubscriptionUrbanTypeId",
                            "operator": "equals",
                            "value": subscriptionRegion,
                            "andOr": "and"
                        }
                    ]
                }
            });
            if(!selectedSlabData){
                lastSlabDetails();
            }
        }
    },[category,subscriptionRegion]);
    const subscriptionFee = watch('subscriptionFee');
    useEffect(()=>{
        if(subscriptionFee){
            const gstAmount = Math.round(subscriptionFee * 0.18);
            const totalAmount = parseInt(subscriptionFee) + gstAmount;
            setValue('subscriptionFeeWithGst',totalAmount);
        }else{
            setValue('subscriptionFeeWithGst',0);
        }
    },[subscriptionFee]);

    const [duplicateEntry, setDuplicateEntry] = useState(false);
    const handleModalClose = () => {
        setDuplicateEntry(false);
        fetchSlabList();
    }
  return (
    <>
    <PermissionGuard feature="gst" permission={selectedSlabData ?'canEdit':"canCreate"} fallback={selectedSlabData && <UnauthorizedPage/>}>
        <Card>
            {isSubmitted && Submitting()}
            <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >{pageTitle}</Typography>
            </Box>
            <Box component={'form'} onSubmit={handleSubmit(onSubmit)} sx={{p:1}}>
                
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Service Category <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Box sx={{display:'flex',alignItems:'center',gap:1,flexGrow:1,flexDirection:{xs:'column',sm:'row'}}}>
                            <Controller
                                name='categoryId'
                                control={control}
                                rules={{ required: 'select category' }}
                                render={({ field, fieldState: { error } }) => (
                                    <Autocomplete
                                        fullWidth
                                        options={categoryList}
                                        getOptionLabel={(option) => option?.title || ''}
                                        isOptionEqualToValue={(option, value) =>
                                            option.id === value?.id || option.id === value
                                        }
                                        value={categoryList.find(cat => cat.id === field.value) || null}
                                        onChange={(event, newValue) => {
                                            let finalValue = newValue?.id || null;
                                            field.onChange(finalValue);
                                        }}
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                // label="Select SAC Code*"
                                                placeholder='Search and Select Category'
                                                error={!!error}
                                                // helperText={error ? error.message : ''}
                                                size="small"
                                                inputProps={{
                                                    ...params.inputProps,
                                                    style: { fontSize: '0.75rem' }
                                                }}
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <MenuItem {...props} style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                {option.title || ''}
                                            </MenuItem>
                                        )}
                                    />
                                )}
                            />
                            {loadingCategoryList && <CircularProgress />}
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600 }}>Subscription Type <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box> : </Typography>
                        <Box sx={{display:'flex',alignItems:'center',gap:1}}>
                            <Controller
                                name='SubscriptionUrbanTypeId'
                                control={control}
                                rules={{
                                    required: 'please select one urban type'
                                }}
                                render={({field,fieldState:{error}})=>
                                    <FormControl sx={{ minWidth: "90%" }} size="small">                                            
                                        <Select
                                            {...field}
                                            error={!!error}
                                            sx={{
                                                fontSize:'0.65rem',
                                            }}
                                        >    
                                        {
                                            urbanTypeList && urbanTypeList.length> 0 && urbanTypeList.map(urban=>(
                                                <MenuItem key={urban.id} value={urban.id} sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>{urban.typeTitle}</MenuItem>
                                            ))
                                        }                                
                                        </Select>
                                    </FormControl>
                                }
                            />
                            {(category && subscriptionRegion) && <Tooltip title="Duplicate for selected Category and Subscription Type from other slabs">
                                <IconButton size='small' onClick={()=>setDuplicateEntry(true)}>
                                    <ControlPointDuplicate fontSize="small" color='warning'/>
                                </IconButton>
                            </Tooltip>}
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600 }}>Booking order Range <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box> : </Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={5}>
                                <Controller
                                    name="orderStart"
                                    control={control}
                                    rules={{
                                    required: 'Value is required',
                                    validate: (value) => {
                                        const intValue = parseInt(value, 10);
                                        return !isNaN(intValue) && intValue >= 0 || 'Value should be a non-negative integer';
                                    }
                                    }}
                                    defaultValue={0}
                                    render={({ field, fieldState: { error } }) => (
                                    <TextField
                                        {...field}
                                        disabled
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            let finalValue;
                                            
                                            // Adjust regex based on integer/float requirement
                                            const isInteger = true; // or false for float
                                            const pattern = isInteger ? /^\d*$/ : /^\d*\.?\d*$/;
                                            
                                            if (inputValue === '' || pattern.test(inputValue)) {
                                                finalValue = normalizeNumericInput(inputValue, isInteger ? 'integer' : 'float');
                                                console.log("finalValue", finalValue);

                                                if(finalValue === ''){
                                                    finalValue = 0;
                                                }

                                                field.onChange(finalValue);
                                            }
                                        }}
                                        fullWidth
                                        type="number"
                                        inputMode="numeric"
                                        size="small"
                                        inputProps={{
                                            style: { textAlign: 'center', height: '1rem',fontSize:'0.65rem'},
                                            min: 0,
                                            step: 1, // Only allow whole numbers
                                            onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                                onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                            onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                            onKeyDown: (e) => {
                                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                    e.preventDefault();
                                                }
                                            }
                                        }}
                                        error={!!error}
                                    />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={2} sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                <Typography sx={{fontSize:'0.85rem',fontWeight:600}} >-</Typography>
                            </Grid>
                            <Grid item xs={5}>
                                <Controller
                                    name="orderEnd"
                                    control={control}
                                    rules={{
                                    required: 'Value is required',
                                        //want to validate this value should be gretaer than orderStart

                                        validate: (value) => {
                                            const intValue = parseInt(value, 10);
                                            const orderStartValue = parseInt(watch('orderStart'), 10);
                                            if (isNaN(intValue) || intValue < 0) {
                                                return 'Value should be a non-negative integer';
                                            }
                                            
                                            if (intValue <= orderStartValue) {
                                                return 'Order End must be greater than Order Start';
                                            }
                                            
                                            return true;
                                        }
                                    }}
                                    defaultValue={0}
                                    render={({ field, fieldState: { error } }) => (
                                    <TextField
                                        {...field}
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            let finalValue;
                                            
                                            // Adjust regex based on integer/float requirement
                                            const isInteger = true; // or false for float
                                            const pattern = isInteger ? /^\d*$/ : /^\d*\.?\d*$/;
                                            
                                            if (inputValue === '' || pattern.test(inputValue)) {
                                                finalValue = normalizeNumericInput(inputValue, isInteger ? 'integer' : 'float');
                                                console.log("finalValue", finalValue);

                                                if(finalValue === ''){
                                                    finalValue = 0;
                                                }

                                                field.onChange(finalValue);
                                            }
                                        }}
                                        fullWidth
                                        type="number"
                                        inputMode="numeric"
                                        size="small"
                                        inputProps={{
                                            style: { textAlign: 'center', height: '1rem',fontSize:'0.65rem'},
                                            min: 0,
                                            step: 1, // Only allow whole numbers
                                            onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                                onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                            onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                            onKeyDown: (e) => {
                                                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                    e.preventDefault();
                                                }
                                            }
                                        }}
                                        error={!!error}
                                    />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Subscription Fee (Base) <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name="subscriptionFee"
                            control={control}
                            rules={{
                            required: 'Value is required',
                            validate: (value) => {
                                const intValue = parseInt(value, 10);
                                return !isNaN(intValue) && intValue >= 0 || 'Value should be a non-negative integer';
                            }
                            }}
                            defaultValue={0}
                            render={({ field, fieldState: { error } }) => (
                            <TextField
                                {...field}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    let finalValue;
                                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                    finalValue = normalizeNumericInput(inputValue);
                                    console.log("finalValue",finalValue)

                                    if(finalValue==''){
                                        finalValue=0
                                    }

                                    field.onChange(finalValue);
                                    }
                                }}
                                fullWidth
                                type="number"
                                inputMode="numeric"
                                size="small"
                                inputProps={{
                                    style: { textAlign: 'center', height: '1rem',fontSize:'0.65rem'},
                                    min: 0,
                                    step: 1, // Only allow whole numbers
                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                        onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                    onKeyDown: (e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                error={!!error}
                            />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Subscription Fee (with GST) <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name="subscriptionFeeWithGst"
                            control={control}
                            rules={{
                            required: 'Value is required',
                            validate: (value) => {
                                const intValue = parseInt(value, 10);
                                const baseSubscriptionFee = parseInt(watch('subscriptionFee'), 10);
                                if (isNaN(intValue) || intValue < 0) {
                                    return 'Value should be a non-negative integer';
                                }
                                
                                if (intValue < baseSubscriptionFee) {
                                    return 'Order End must be greater than Order Start';
                                }
                                
                                return true;
                            }
                            }}
                            defaultValue={0}
                            render={({ field, fieldState: { error } }) => (
                            <TextField
                                {...field}
                                disabled
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    let finalValue;
                                    if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                    finalValue = normalizeNumericInput(inputValue);
                                    console.log("finalValue",finalValue)

                                    if(finalValue==''){
                                        finalValue=0
                                    }

                                    field.onChange(finalValue);
                                    }
                                }}
                                fullWidth
                                type="number"
                                inputMode="numeric"
                                size="small"
                                inputProps={{
                                    style: { textAlign: 'center', height: '1rem',fontSize:'0.65rem'},
                                    min: 0,
                                    step: 1, // Only allow whole numbers
                                    onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                        onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused 
                                    onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                    onKeyDown: (e) => {
                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                        }
                                    }
                                }}
                                error={!!error}
                            />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:2}}>
                        <Button 
                            variant='contained' 
                            size='small' 
                            color='error'
                            onClick={resetFormField}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant='contained' 
                            size='small' 
                            type='submit'
                            disabled={!isDirty}
                        >
                            {selectedSlabData ? 'update':'Save'}
                        </Button>
                    </Grid>
                </Grid>
                
                
            </Box>
        </Card>
    </PermissionGuard>
    <Modal
        open={duplicateEntry}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
        >
        <Box
            sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%"},
            minHeight: '25%',
            maxHeight: '90%'
            }}

            borderRadius={2}
        >
            <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
                <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
                    Copy Other Category Slab Entry
                </Typography>
                <IconButton
                    size='small'
                    onClick={handleModalClose}
                    sx={{ p: 0 }}
                    color='error'
                >
                    <Close sx={{fontSize:{xs:'1rem',sm:'1.25rem'}}}/>
                </IconButton>
            </Box>
            {/* <PaymentDescription/> */}
            <MultipleDuplicateSlabCreate categoryId={category} SubscriptionUrbanTypeId={subscriptionRegion} closeModal={handleModalClose}/>
        </Box>
    </Modal>
    </>
  );
}

export default AddEditForm;